import * as queryString from "query-string";
import React from "react";
import { connect } from "react-redux";
import { Container } from "semantic-ui-react";

import { createAccount } from "../actions/accounts/accounts";
import { getPencilerRegions } from "../actions/regions/regions";
import CreateAccount from "../components/accounts/CreateAccount";
import { exists } from "../utils/utils";

/**
 * Create account view.
 * Used for rendering the CreateAccount component and interacting with Redux.
 */
class CreateAccountView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDemo: false
    };
    if (
      exists(this.props.location) &&
      exists(queryString.parse(this.props.location.search).is_demo)
    ) {
      this.state.isDemo = queryString.parse(this.props.location.search).is_demo === "true";
    }
    this.props.getPencilerRegions();
  }

  render() {
    return (
      <Container>
        <CreateAccount
          onSubmit={values => {
            this.props.createAccount(values);
          }}
          isDemo={this.state.isDemo}
        />
      </Container>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  createAccount: accountFields => dispatch(createAccount(accountFields)),
  getPencilerRegions: () => dispatch(getPencilerRegions())
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateAccountView);
